import { Button, ColorPicker, Form, Input, message, Typography } from 'antd';
import React, { useState } from 'react';
import './ModalState.scss';
import { useTranslation } from '../../i18n/i18n';
import { PlusOutlined } from '@ant-design/icons';
import { installationStateApi } from '../../api/installation-state.api';
import ModalCustom from '../utils/ModalCustom/ModalCustom';

const { Text } = Typography;

interface ModalStateProps {
  onSaved?: () => void;
}

const ModalState = ({ onSaved }: ModalStateProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [color, setColor] = useState<string>('#1677ff');
  const { t } = useTranslation('location', { keyPrefix: 'modals' });
  const [messageApi, contextHolder] = message.useMessage();

  const handleSave = async () => {
    try {
      await installationStateApi.createInstallationState(name, color);
      onSaved?.();
    } catch (error) {
      messageApi.error(t('common:errors.generic'));
    } finally {
      setIsModalOpen(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Button type={'primary'} onClick={() => setIsModalOpen(true)}>
        <PlusOutlined />
        {t('newState')}
      </Button>
      <ModalCustom
        title={t('createState')}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        footer={
          <Button type={'primary'} onClick={handleSave}>
            {t('save')}
          </Button>
        }
        description={t('modalCreateDesc')}
      >
        <Form className={'ModalState__form'}>
          <div className={'ModalState__form__item'}>
            <Text>{t('name')}</Text>
            <Input className={'ModalState__form__item__input'} value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className={'ModalState__form__item ModalState__form__item__color'}>
            <Text>{t('color')}</Text>
            <ColorPicker
              className={'ModalState__form__color'}
              value={color}
              showText
              onChange={(value) => setColor(value.toHexString())}
              disabledAlpha
              disabledFormat
            />
          </div>
        </Form>
      </ModalCustom>
    </>
  );
};

export default ModalState;
